import { useState, useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useLocation } from "react-router-dom";
import { getListUserAttendance, submitCheckinAttendance } from '../../../../../../api/repositories'
import { WebSocketURL } from "../../../../../../config/config";
import { listUserAttendance } from "../constant";



const useActions = (valueSearch) => {
    const [ loadingListUser, setLoadingListUser ] = useState(true)
    const [ listDataUser, setListDataUser ] = useState([]);
    const [ loadingFetching, setLoadingFetching] = useState(true) // state loading only for fetch
    const [ dataAccomodate, setDataAccomodate ] = useState([]) // real data from API
    const [ userFullnameCheckin, setUserFullnameCheckin ] = useState();
    const [ sucUserFullname, setSucUserFullname ] = useState();
    const [ sucUserDateCheckin, setSucUserDateCheckin ] = useState();
    const [ useridCheckin, setUseridCheckin ] = useState();
    const [ statusCheckin, setStatusCheckin ] = useState();
    const [ loadingPushWs, setLoadingPushWs ] = useState(false);

    let location = useLocation()
    const path = location.pathname;
    const page = path.split('/');

    const fetchListUser = async(program_id) => {
        setLoadingListUser(true);
        setLoadingFetching(true)
    
        try {
            const { data, status } = await getListUserAttendance(program_id);
            // const { data, status } = listUserAttendance;
            
            if(status === 200){
                setListDataUser(data);
                setDataAccomodate(data);
            }
            
        } catch (err) {
            console.log("Error fetch List User Attendance "+err)
            setListDataUser([]);
            setDataAccomodate([]);
        } finally {
            setLoadingListUser(false)
            setLoadingFetching(false)
        }
    };

    const pushWebSocket = (data) => {
        return new Promise((resolve, reject) => {
            let isSuccess = false;

            const connect = () => {
                const ws = new WebSocket(WebSocketURL);

                ws.onopen = () => {
                    const payload = data;
                    ws.send(JSON.stringify(payload));
                    console.log("WebSocket data sent:", payload);
                    isSuccess = true;
                    resolve("sent");
                    setTimeout(() => ws.close(), 500); // Close shortly after sending
                };

                ws.onmessage = (event) => {
                    console.log("WebSocket response:", event.data);
                };

                ws.onerror = (error) => {
                    console.error("WebSocket error:", error);
                    ws.close();
                };

                ws.onclose = () => {
                    if (!isSuccess) {
                        console.log("WebSocket connection closed. Attempting to reconnect...");
                        setTimeout(() => {
                            connect();
                        }, 3000);
                    } else {
                        console.log("WebSocket connection closed normally.");
                    }
                };
            };
            
            connect();
        });
    };


    const submitCheckinUser = async(userid) => {
        setLoadingPushWs(true);

        const payload = {
            program_id:parseInt(page[2]),
            user_id:userid
        }

        try {
            const { status, data } = await submitCheckinAttendance({data: payload});
            
            // dummy data for testing websocket
            // const isiData = {
            //     "user_id": 32964,
            //     "date": "2026-09-11 14:17:20",
            //     "fullname": "Christover Kaya Raya Amin",
            //     "class": "class of 2027",
            //     "location": "Ruko Maggiore",
            //     "location_online": "Online"
            // }

            if(status === 200){
                const datawebsocket = {
                    "type": "push",
                    "userId": userid,
                    "success": true,
                    "data": JSON.stringify(data)
                }
                
                await pushWebSocket(datawebsocket);

                setStatusCheckin("success");
                setSucUserFullname(data.fullname);
                setSucUserDateCheckin(data.date);
            } else {
                setStatusCheckin("failed");
                setSucUserFullname(undefined);
                setSucUserDateCheckin(undefined);
            }
            
        } catch (err) {
            console.log("Error Submit User Checkin "+err)
            setStatusCheckin("failed");
            setSucUserFullname(undefined);
            setSucUserDateCheckin(undefined);
        } finally {
            setLoadingPushWs(false);
        }
    }

    const filterSearching = (value, data) => {
        
        const trimResult = data.filter((e) => {
            const fullname = e.firstname+" "+e.lastname;
            if(fullname.toLowerCase().indexOf(value.toLowerCase()) > -1) return true
        })
        setListDataUser(trimResult)

        // console.log(trimResult)
        
        setLoadingListUser(false);
    }

    useEffect(() => {
        // refetch every change userid because fast pace
        fetchListUser(parseInt(page[2]))
    },[useridCheckin])

    useEffect(() => {
        if(loadingFetching === false){
            setLoadingListUser(true)
            const delayDebounceFn = setTimeout(() => {
                filterSearching(valueSearch, dataAccomodate);
            }, 800)
                
            return () => clearTimeout(delayDebounceFn)
        }
    },[valueSearch])
    
    return{
        loadingListUser,
        listDataUser,
        useridCheckin,
        setUseridCheckin,
        statusCheckin,
        submitCheckinUser,
        userFullnameCheckin,
        setUserFullnameCheckin,
        sucUserFullname,
        sucUserDateCheckin,
        setSucUserFullname,
        setSucUserDateCheckin,
        setStatusCheckin,
        loadingPushWs
    }
}

export default useActions